<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome da gestante"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :item-class="getRowColor"
          :items="indexedItems"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteEsusPecGlobal />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>

          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>
          <template v-slot:header.dt_atendimento="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Última consulta realizada na gestante com informação de CID ou CIAP de pré-natal"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:header.proxima_consulta="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Recomendação de data máxima para realizar a próxima consulta com base no protocolo de pré-natal e idade gestacional atual da gestante"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.id="{ item }">
            {{ item.id == null ? item.nu_cpf_cns : item.id }}
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}
          </template>
          <template v-slot:item.dt_atendimento="{ item }">
            {{
              item.dt_atendimento !== null
                ? formatDate(item.dt_atendimento) + ` (${item.dias} dias)`
                : 'Auto referido'
            }}
          </template>
          <template v-slot:item.dt_ultima_hemoglobina="{ item }">
            {{ formatDate(item.dt_ultima_hemoglobina) }}
          </template>

          <template v-slot:item.proxima_consulta="{ item }">
            {{
              item.dt_atendimento === null
                ? 'Auto referido'
                : item.tipo_atendimento == 2
                ? 'Fechado'
                : formatDate(item.proxima_consulta)
            }}
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="7">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CNS</th>
                    <th>CPF</th>
                    <th>DUM</th>
                    <th>DPP</th>
                    <th>DPP +14 Dias</th>
                    <th>Desfecho</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <show-hide-field :value="item.nu_cns"></show-hide-field>
                    </td>
                    <td>
                      <show-hide-field :value="item.nu_cpf"></show-hide-field>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{
                          item.dt_dum !== null ? formatDate(item.dt_dum) : ''
                        }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{ item.dpp !== null ? formatDate(item.dpp) : '' }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{
                          item.dt_dum !== null
                            ? formatDate(item.fechar_ate)
                            : ''
                        }}
                      </div>
                    </td>
                    <td>
                      <div class="d-block mb-2">
                        {{
                          item.dt_atendimento === null
                            ? ''
                            : item.tipo_atendimento == 1
                            ? 'Aberto'
                            : 'Fechado'
                        }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-app>
</template>

<script>
import * as Functions from './functions'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'MA',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },

        {
          text: 'Última Consulta',
          align: 'start',
          filterable: false,
          value: 'dt_atendimento',
        },
        {
          text: 'Prox. Consulta',
          align: 'start',
          filterable: false,
          value: 'proxima_consulta',
        },
        { text: '', value: 'data-table-expand' },
      ],
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        id: index,
        ...item,
      }))
    },
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      return `table-row-color-${this.printTableRow(
        item.proxima_consulta,
        item.dt_atendimento,
        item.tipo_atendimento
      )}`
    },

    printTableRow(proxima_consulta, dt_atendimento, tipo_atendimento) {
      return Functions.printTableRow(
        proxima_consulta,
        dt_atendimento,
        tipo_atendimento
      )
    },
  },
}
</script>

<style scoped lang="scss"></style>
